import * as React from "react";
const UspGroupItemContainer = ({
  renderAsListItem,
  children
}) => {
  if (renderAsListItem) {
    return /* @__PURE__ */ React.createElement("li", { className: "usp-group-list-item" }, children);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export {
  UspGroupItemContainer
};
//# sourceMappingURL=UspGroupItemContainer.js.map
